import React, { Fragment } from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../AbstractElements';
import EditQuestionsTable from './EditQuestion';
const EditQuestions = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle='Edit Questions' parent='Edit Questions'  />
      <Container fluid={true}>
        <Row>
          <EditQuestionsTable />
        </Row>
      </Container>
    </Fragment>
  );
};

export default EditQuestions;
